import { HTMLLink, LayoutServiceData } from "@sitecore-jss/sitecore-jss-nextjs";
import Placeholder from "@repo/sitecore-lib/Placeholder";
import BaseLayout from "./base-layout";

export interface MainLayoutProps {
  layoutData: LayoutServiceData;
  headLinks: HTMLLink[];
}

const MainLayout = ({
  layoutData,
  headLinks,
}: MainLayoutProps): JSX.Element => {
  const { route } = layoutData.sitecore;
  const placeholders = route?.placeholders;

  return (
    <BaseLayout layoutData={layoutData} headLinks={headLinks}>
      {route &&
        placeholders &&
        Object.entries(placeholders).map(([key]) => (
          <Placeholder
            key={key}
            name={key}
            rendering={route}
            classname="heroPlaceholder"
          />
        ))}
    </BaseLayout>
  );
};

export default MainLayout;
